import { createReferenceAdapter } from '../../references';
import type {
  DisclaimerMessageReferences,
  GreetingReferences,
  LanguageBehaviorReferences,
  PersonalityReferences,
  RoleReferences,
  RulesReferences,
} from './types';

// Greeting
const greetingReferences: GreetingReferences[] = ['variables', 'translations'];

export const greetingReferencesAdapter =
  createReferenceAdapter(greetingReferences);

// Personality
const personalityReferences: PersonalityReferences[] = ['variables'];

export const personalityReferencesAdapter = createReferenceAdapter(
  personalityReferences,
);

// Role
const rolesReferences: RoleReferences[] = ['variables'];

export const rolesReferencesAdapter = createReferenceAdapter(rolesReferences);

// Rules
const rulesReferences: RulesReferences[] = [
  'attributes',
  'globalFunctions',
  'handoff',
  'sms',
  'variables',
  'translations',
];

export const rulesReferencesAdapter = createReferenceAdapter(rulesReferences);

// Language behavior
export const languageBehaviorReferences: LanguageBehaviorReferences[] = [
  'attributes',
  'globalFunctions',
  'handoff',
  'sms',
  'variables',
];

export const languageBehaviorReferencesAdapter = createReferenceAdapter(
  languageBehaviorReferences,
);

// Disclaimer message
const disclaimerMessageReferences: DisclaimerMessageReferences[] = [
  'translations',
];

export const disclaimerMessageReferencesAdapter = createReferenceAdapter(
  disclaimerMessageReferences,
);
